import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["legal", "privacy"]

  openLegal() {
    this.legalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  closeLegal() {
    this.legalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  openPrivacy() {
    this.privacyTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  closePrivacy() {
    this.privacyTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  // Close modal when clicking outside
  closeOnBackdrop(event) {
    if (event.target === this.legalTarget) {
      this.closeLegal()
    }
    if (event.target === this.privacyTarget) {
      this.closePrivacy()
    }
  }
}
